export enum Language { 'Portuguese' = 'pt', 'English' = "en", 'French' = 'fr'}
